import { createFileRoute } from '@tanstack/react-router';
import { buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { OFAC_SDN_BASE_PATH } from '../../../../../../../../../features/watchlist/ofac/sdn/ofac-sdn-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/ofac/sdn/_sdn')({
  loader: () => ({
    breadcrumb: buildBreadcrumb({
      id: 'ofac-sdn-list',
      label: 'OFAC',
      to: OFAC_SDN_BASE_PATH,
    }),
  }),
});
